<template>
  <div class="summary-container">
    <div class="summary">
      <h2>Payment Summary</h2>
      <!-- <div class="tenure-section">
          <h4>Set Tenure</h4>
          <div class="tenure-bar">
            <div class="point">
              <p>0</p>
            </div>
            <div class="point" v-for="item of tenureItems" :key="item.point" @click="setActivePoints(item.point)">
              <p
                :class="item.marked ? 'marked' : ''"
              >
                {{ item.marked ? item.point + " months" : item.point }}
              </p>
              <div v-show="item.marked && item.active" :class="item.marked ? 'marked' : ''"></div>
              <div v-show="!item.marked" :class="item.active ? 'active' : ''"></div>
            </div>
          </div>
          <div class="base-line">
            <div class="blue-line" :style="{width: `${getProgressPercent}%`}"></div>
          </div>
        </div> -->

      <!-- Quantity of Inverters -->
      <div class="form-group row quantity">
        <label class="col-lg-4 col-form-label" for="quantity"
          >Quantity of Inverter:
        </label>
        <div class="col-lg-8">
          <input
            type="number"
            name="quantity"
            id="quantity"
            min="1"
            max="500"
            width="25%"
            v-model="quantity"
          />
        </div>
      </div>

      <!-- Full Address -->
      <div class="form-group row address">
        <label class="col-lg-4 col-form-label" for="address"
          >Full Address:
        </label>
        <div class="col-lg-8">
          <input
            class="form-control form-control-lg"
            type="text"
            name="address"
            id="address"
            v-model="address"
          />
        </div>
      </div>

      <!-- Only Display if A STANDARD CUSTOMER -->
      <div
        v-show="
          this.$store.state.activateCustomerType == 'Standard Customer'
            ? true
            : false
        "
      >
        <!-- Down Payment -->
        <div class="form-group row downPayment">
          <label class="col-lg-4 col-form-label" for="downPayment"
            >Down Payment Percentage:
          </label>
          <div class="col-lg-8">
            <select class="form-control form-control-lg" v-model="downPayment">
              <option disabled value="">Select down payment percentage</option>
              <option
                v-for="item in loopDownPayment"
                :value="item.value"
                :key="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Number of Payment Month -->
        <div class="form-group row tenureMonth">
          <label class="col-lg-4 col-form-label" for="tenureMonth"
            >Tenure (in Months):
          </label>
          <div class="col-lg-8">
            <select class="form-control form-control-lg" v-model="tenureMonth">
              <option disabled value=""
                >Select number of repayable tenure</option
              >
              <option
                v-for="item in loopTenureMonth"
                :value="item.value"
                :key="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- Building Type -->
        <div class="form-group row buildingType">
          <label class="col-lg-4 col-form-label" for="buildingType"
            >Building Type:
          </label>
          <div class="col-lg-8">
            <select class="form-control form-control-lg" v-model="buildingType">
              <option disabled value="">Select your building type</option>
              <option
                v-for="item in loopBuildingType"
                :value="item.value"
                :key="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="summary-table">
        <div>
          <p>Total 1st Month Payment (payable now)</p>
          <p>
            NGN
            {{
              Intl.NumberFormat("en-US").format(
                3 * +activePackage.monthlyPaymentValue
              )
            }}
          </p>
        </div>
        <div class="tabbed">
          <p>2 Months Upfront Payment</p>
          <p>
            NGN
            {{
              Intl.NumberFormat("en-US").format(
                2 * +activePackage.monthlyPaymentValue
              )
            }}
          </p>
        </div>
        <div class="tabbed">
          <p>Caution fee (Refundable)</p>
          <p>
            NGN
            {{ Intl.NumberFormat("en-US").format(activePackage.cautionFee) }}
          </p>
        </div>
        <div class="tabbed">
          <p>Starting Monthly Payment</p>
          <p>
            NGN
            {{
              Intl.NumberFormat("en-US").format(
                activePackage.monthlyPaymentValue
              )
            }}
          </p>
          <img
            :src="require('../../../../assets/img/multi-arrow.svg')"
            class="arrows"
          />
        </div>
        <!-- <div class="bold-text">
            <p>Starting Monthly Payments</p>
            <p>
              NGN {{ Intl.NumberFormat("en-US").format(monthlyPaymentValue) }}
            </p>
          </div> -->
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        System ownership is transferred upon meeting all lease obligations
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/female-wave.gif')" alt="" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LOSummary",
  props: ["updateStatus", "updateTracker", "getCustomerProductDetails"],
  computed: {
    ...mapGetters(["getUserSession"]),
    getProgressPercent() {
      let percent;
      this.tenureItems.map(item => {
        if (item.point == this.activeTenure) percent = item.percent;
      });
      return percent;
    }
  },
  watch: {
    quantity(newValues, oldValues) {
      if (!newValues) return;
      this.activePackage = {
        firstPaymentAmt: 3 * +this.loAmount * newValues,
        cautionFee: +this.loAmount * newValues,
        monthlyPaymentValue: +this.loAmount * newValues
      };
      this.setActivePoints(this.activeTenure);
    }
  },
  data() {
    return {
      loAmount: 1,
      activeTenure: 6,
      quantity: 1,
      address: "",
      downPayment: "",
      loopDownPayment: [
        { name: "20%", value: 20, id: 1 },
        { name: "30%", value: 30, id: 2 },
        { name: "40%", value: 40, id: 3 },
        { name: "50%", value: 50, id: 4 },
        { name: "60%", value: 60, id: 5 },
        { name: "70%", value: 70, id: 6 },
        { name: "80%", value: 80, id: 7 },
        { name: "90%", value: 90, id: 8 },
        { name: "100%", value: 100, id: 9 }
      ],
      tenureMonth: "",
      loopTenureMonth: [
        { name: "6 Months", value: 6, id: 1 },
        { name: "12 Months", value: 12, id: 2 },
        { name: "18 Months", value: 18, id: 3 },
        { name: "24 Months", value: 24, id: 4 },
        { name: "30 Months", value: 30, id: 5 },
        { name: "36 Months", value: 36, id: 6 }
      ],
      buildingType: "",
      loopBuildingType: [
        { name: "Bungalow", value: "Bungalow", id: 1 },
        { name: "Duplex", value: "Duplex", id: 2 },
        { name: "3 Storey Building", value: "3 Storey Building", id: 3 },
        { name: "Face-me I-Slap you", value: "Face-me I-Slap you", id: 4 }
      ],
      tenureItems: [
        {
          point: 6,
          percent: 17.5
        },
        {
          point: 12,
          percent: 33.5
        },
        {
          point: 18,
          percent: 50
        },
        {
          point: 24,
          percent: 66
        },
        {
          point: 30,
          percent: 82.5
        },
        {
          point: 36,
          percent: 100,
          active: true
        }
      ],
      typeProduct: 0,
      productName: "",
      monthlyPaymentValue: "",
      activePackage: {
        firstPaymentAmt: 1,
        cautionFee: 1,
        monthlyPaymentValue: 1
      },
      setActivePoints(point) {
        let activeStatus = true;
        this.unmarkPoints();
        this.tenureItems.map(item => {
          item.active = activeStatus;
          if (item.point == point) {
            this.activeTenure = point;
            item.marked = true;
            activeStatus = false;
          }
        });

        this.$store.state.onboardingCustomerState.tenure = this.activeTenure;
        this.PMT(0.015, this.activeTenure, this.typeProduct, 0, 0);

        this.getCustomerProductDetails({
          customerid: this.getUserSession.id,
          productid: this.productPackage.id,
          tenure: this.activeTenure,
          firstpaymentamt: this.activePackage.firstPaymentAmt,
          recurrentmonthlyamt: parseFloat(this.monthlyPaymentValue),
          monthlyincomerange: "",
          employmentstatus: "",
          totalpayment:
            this.activeTenure * this.monthlyPaymentValue +
            0.05 * this.typeProduct,
          cautionfee: parseFloat(this.monthlyPaymentValue),
          setupfee: "0",
          typeofbusiness: "Micheal, please remove this and upfrontPayment",
          upfrontpayment: 0
        });
      }
    };
  },
  methods: {
    unmarkPoints() {
      this.tenureItems.map(item => delete item.marked);
    },
    PMT(rate = 0.015, nperiod, pv, fv = 0, type = 0) {
      if (rate == 0) return -(pv + fv) / nperiod;

      var pvif = Math.pow(1 + rate, nperiod);
      var pmt = (rate / (pvif - 1)) * -((pv - 0.05 * pv) * pvif + fv);

      if (type == 1) {
        pmt /= 1 + rate;
      }
      this.monthlyPaymentValue =
        Math.abs(pmt) === "Infinity" ? 0.0 : Math.abs(pmt).toFixed(2);
    },
    getProductPackage() {
      this.productPackage = this.$store.state.onboardingPackageType;
      this.typeProduct = this.productPackage.amountOS;
      this.productName = this.productPackage.name;
    }
  },
  mounted() {
    console.log("rfsf", this.$store.state.onboardingCustomerState);
    this.updateTracker(true);
    this.updateStatus(1);
    this.PMT(0.015, this.activeTenure, this.typeProduct, 0, 0);
  },
  beforeMount() {
    this.loAmount = this.$store.state.onboardingLoMonthlyAmount;
    this.activePackage = {
      firstPaymentAmt: 3 * +this.loAmount,
      cautionFee: +this.loAmount,
      monthlyPaymentValue: +this.loAmount
    };
    this.getProductPackage();
    this.setActivePoints(this.activeTenure);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

.downPayment {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}
.tenureMonth {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.buildingType {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
  }
}

.address {
  width: 102% !important;
  label {
    margin: 24px 0;
    color: #727272;
    font-size: 16px;
    // font-weight: normal;
  }
}

.quantity label {
  font-size: 16px;
  color: #727272;
  // font-weight: normal;
}
.quantity input {
  width: 50px;
  border-radius: 6px;
  height: 30px;
  margin-left: 6px;
  border: 1px solid #d3d9dd;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
}

.summary-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.summary {
  width: 55%;
  box-shadow: 1px 1px 5px #d9d9d9;

  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  > div {
    width: 100%;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 17px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p {
        color: #000000;
        font-size: 16px;
      }

      p:last-child {
        text-align: right;
        width: 30%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .bold-text p {
      font-weight: bold;
    }

    .tabbed {
      position: relative;
    }

    .tabbed p {
      margin-left: 55px;
    }

    .tabbed .arrows {
      position: absolute;
      bottom: 30px;
      left: 25px;
    }
  }

  .tenure-section {
    margin-bottom: 30px;

    h4 {
      color: #fe7a11;
      margin-bottom: 10px;
      font-weight: bold;
    }

    .tenure-bar {
      display: flex;
      justify-content: space-between;

      .point {
        text-align: center;
        position: relative;
        width: 15px;
        overflow-x: visible;
        cursor: pointer;

        &:first-child {
          cursor: text;
        }

        &:last-child {
          text-align: right;
        }

        p {
          color: #efefef;
          font-size: 12px;
          line-height: 16px;
          margin-bottom: 2px;
          height: 20px;
        }

        div {
          width: 3px;
          height: 8px;
          border-radius: 2px;
          background: #efefef;
          display: inline-block;
        }

        div.active {
          background: #ace5ff;
        }

        p.marked {
          padding: 2px 8px;
          border-radius: 5px;
          background: #0892d0;
          width: 80px;
          margin-left: -32.5px;
        }

        div.marked {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background: #0892d0;
        }
      }
    }

    .base-line {
      background: #efefef;
      height: 5px;
      border-radius: 9px;
      margin-top: -14px;

      .blue-line {
        width: 82.5%;
        height: 5px;
        background: #ace5ff;
        border-radius: 9px;
      }
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/LOSummary.vue